import {
  Anchor,
  Button,
  CardHeader,
  cx,
  IconCaretDown,
  IconCaretUp,
  Text,
  Tooltip,
  useCollapse,
} from '@vtex/admin-ui'
import { DefaultProps, Event } from 'typings'
import { useAnalytics } from 'use-analytics'
import { styles } from './styles'

interface Props extends DefaultProps {
  name: string
  icon: React.ReactNode
  title: string
  link: string
}

export function CardItem(props: Props) {
  const { name, icon, title, link, children } = props

  const { track } = useAnalytics()

  const { getToggleProps, getCollapseProps, visible } = useCollapse({
    visible: false,
  })

  const { onClick, ...restToggleProps } = getToggleProps()

  const handleHeaderClick = () => {
    if (!visible) {
      track(Event.FORMULA_CARD_OPEN, {
        name,
      })
    }

    onClick()
  }

  const handleAnchorClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    track(Event.LEARN_MORE_CLICK, {
      origin: `regular-benefit-formula-card-${name}`,
      target: link,
    })
  }

  return (
    <div className={cx(styles.card.item, 'card-item')}>
      <CardHeader
        data-visible={visible}
        className={styles.card.header}
        onClick={handleHeaderClick}
        {...restToggleProps}
      >
        <div className={styles.card.info}>
          {icon}
          <Text variant="body">{title}</Text>
        </div>

        <div className={styles.card.actions}>
          <Anchor
            onClick={handleAnchorClick}
            target="_blank"
            href={link}
            className={styles.card.anchor}
          >
            <Tooltip visible={false} text="" />
          </Anchor>
          <Button
            variant="neutralTertiary"
            icon={
              visible ? (
                <IconCaretUp size="small" />
              ) : (
                <IconCaretDown size="small" />
              )
            }
          />
        </div>
      </CardHeader>
      <div {...getCollapseProps()}>
        <div className={styles.card.content}>{children}</div>
      </div>
    </div>
  )
}
